import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54b58a15"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "is-flex is-flex-direction-row is-align-items-center" };
const _hoisted_2 = {
    key: 0,
    class: "mr-3"
};
const _hoisted_3 = {
    key: 0,
    class: "is-flex is-flex-direction-row is-align-items-center mt-3"
};
const _hoisted_4 = { class: "ml-2" };
const _hoisted_5 = {
    key: 1,
    class: "is-flex is-flex-direction-row is-align-items-center mt-3"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-pen" }, null, -1));
const _hoisted_8 = {
    key: 0,
    class: "ml-1 desktopLabel"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1));
const _hoisted_11 = {
    key: 0,
    class: "ml-1 desktopLabel"
};
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListEditor',
    props: {
        items: {},
        fixedItemLabel: {},
        headerLabel: {},
        noneLabel: {},
        hideActionLabels: { type: Boolean },
        itemIcon: {},
        itemLabel: { type: Function },
        addLabel: {},
        onAdd: { type: Function },
        onEdit: { type: Function },
        onRemove: { type: Function }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.headerLabel)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_2, _toDisplayString(_ctx.headerLabel), 1))
                        : _createCommentVNode("", true),
                    (_ctx.onAdd)
                        ? (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 1,
                            class: "has-text-left",
                            label: _ctx.addLabel,
                            icon: "fa-plus",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.onAdd()))
                        }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.fixedItemLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("i", {
                            class: _normalizeClass(["fa", _ctx.itemIcon])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.fixedItemLabel), 1)
                    ]))
                    : _createCommentVNode("", true),
                (!_ctx.fixedItemLabel && _ctx.items.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("em", null, _toDisplayString(_ctx.noneLabel || "None specified"), 1)
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "is-flex is-flex-direction-row is-align-items-center mt-3",
                        key: idx
                    }, [
                        (_ctx.itemIcon)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(["fa mr-2", _ctx.itemIcon])
                            }, null, 2))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", null, _toDisplayString(_ctx.itemLabel(item)), 1),
                        (_ctx.onEdit)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "ml-5",
                                onClick: ($event) => (_ctx.onEdit(idx))
                            }, [
                                _hoisted_7,
                                (!_ctx.hideActionLabels)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Edit"))
                                    : _createCommentVNode("", true)
                            ], 8, _hoisted_6))
                            : _createCommentVNode("", true),
                        (_ctx.onRemove)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                class: "ml-5",
                                onClick: ($event) => (_ctx.onRemove(idx))
                            }, [
                                _hoisted_10,
                                (!_ctx.hideActionLabels)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Delete"))
                                    : _createCommentVNode("", true)
                            ], 8, _hoisted_9))
                            : _createCommentVNode("", true)
                    ]));
                }), 128))
            ]));
        };
    }
});
